(function () {
  'use strict';
    var subtotalObservers = [];

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || (window.theme && window.theme.moneyFormat) || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === 'number' ? precision : 2;
      thousands = thousands || '.';
      decimal = decimal || ',';

      if (isNaN(number) || number == null) return '0';

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var fraction = parts[1] ? decimal + parts[1] : '';

      return whole + fraction;
    }

    switch ((formatString.match(placeholderRegex) || [null, 'amount'])[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function parseInteger(value) {
    var normalized = String(value == null ? '' : value).replace(/[^\d\-]/g, '');
    var parsed = parseInt(normalized || '0', 10);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function getScope(node) {
    if (!node || typeof node.closest !== 'function') return document;
    return node.closest('.quick-cart') || node.closest('.cart') || document;
  }

  function getSubtotalNode(scope) {
    if (!scope || typeof scope.querySelector !== 'function') return null;

    return (
      scope.querySelector('[data-quick-cart-subtotal-value]') ||
      scope.querySelector('[data-main-cart-subtotal-value]')
    );
  }

  function getSubtotalCents(scope) {
    var subtotalNode = getSubtotalNode(scope);
    if (!subtotalNode) return 0;

    var centsNode = subtotalNode.querySelector('[data-cart-subtotal-cents]');
    if (centsNode) {
      return parseInteger(centsNode.textContent || '0');
    }

    var centsAttr = subtotalNode.getAttribute('data-cart-subtotal-cents');
    if (centsAttr != null && centsAttr !== '') {
      return parseInteger(centsAttr);
    }

    return 0;
  }

  function updateSummary(summary) {
    if (!summary) return;

    var amountNode = summary.querySelector('[data-cart-cashback-amount]');
    var rate = parseFloat(summary.dataset.cashbackRate || '0');
    var scope = getScope(summary);
    var subtotalCents = getSubtotalCents(scope);

    if (!amountNode || !Number.isFinite(rate) || rate <= 0 || !Number.isFinite(subtotalCents) || subtotalCents <= 0) {
      summary.hidden = true;
      return;
    }

    var cashbackCents = Math.round((subtotalCents * rate) / 100);

    if (!Number.isFinite(cashbackCents) || cashbackCents <= 0) {
      summary.hidden = true;
      return;
    }

    amountNode.textContent = formatMoney(
      cashbackCents,
      (window.theme && window.theme.moneyFormat) || '${{amount}}'
    );

    summary.hidden = false;
  }

  function updateAll(scope) {
    var container = scope && typeof scope.querySelectorAll === 'function' ? scope : document;

    container.querySelectorAll('[data-cart-cashback-summary]').forEach(function (summary) {
      updateSummary(summary);
    });
  }

  function scheduleUpdate(scope, delay) {
    var container = scope && typeof scope.querySelectorAll === 'function' ? scope : document;
    var timerKey = '__cartCashbackSummaryTimer';

    window.clearTimeout(container[timerKey]);

    container[timerKey] = window.setTimeout(function () {
      updateAll(container);
      container[timerKey] = null;
    }, delay || 0);
  }

    function disconnectSubtotalObserversWithin(scope) {
    if (!scope || typeof scope.contains !== 'function') return;

    subtotalObservers = subtotalObservers.filter(function (entry) {
      if (!entry || !entry.node || !entry.observer) return false;

      var shouldDisconnect =
  entry.node === scope ||
  scope.contains(entry.node) ||
  !entry.node.isConnected;

      if (shouldDisconnect) {
        entry.observer.disconnect();

        if (entry.node.dataset) {
          delete entry.node.dataset.cashbackObserverBound;
        }

        return false;
      }

      return true;
    });
  }

  function bindSubtotalObserver(scope) {
    var subtotalNode = getSubtotalNode(scope);
    if (!subtotalNode || subtotalNode.dataset.cashbackObserverBound === 'true') return;

    subtotalNode.dataset.cashbackObserverBound = 'true';

    var observer = new MutationObserver(function () {
      scheduleUpdate(scope, 0);
    });

    observer.observe(subtotalNode, {
      childList: true,
      subtree: true,
      characterData: true
    });

    subtotalObservers.push({
      node: subtotalNode,
      observer: observer
    });
  }

  function initScope(scope) {
    var container = scope && typeof scope.querySelectorAll === 'function' ? scope : document;
    var roots = [];

    if (container.matches && (container.matches('.quick-cart') || container.matches('.cart'))) {
      roots.push(container);
    }

    container.querySelectorAll('.quick-cart, .cart').forEach(function (root) {
      roots.push(root);
    });

    if (!roots.length) {
      roots.push(document);
    }

    roots.forEach(function (root) {
      bindSubtotalObserver(root);
    });

    scheduleUpdate(container, 0);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initScope(document);
  });

  document.addEventListener('quick-cart:open', function (evt) {
    initScope(getScope(evt.target));
  });

  document.addEventListener('cart:updated', function (evt) {
    initScope(getScope(evt.target));
  });

  document.addEventListener('click', function (evt) {
    var trigger = evt.target && evt.target.closest('.quick-cart [data-add-quantity], .quick-cart [data-subtract-quantity], .quick-cart [data-remove-item], .cart [data-add-quantity], .cart [data-subtract-quantity], .cart [data-remove-item]');
    if (!trigger) return;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        scheduleUpdate(getScope(trigger), 0);
      });
    });
  });

  document.addEventListener('change', function (evt) {
    if (evt.target && evt.target.matches('.quick-cart [data-quantity-input], .quick-cart .quantity-input__input, .cart [data-quantity-input], .cart .quantity-input__input')) {
      scheduleUpdate(getScope(evt.target), 0);
    }
  });

  document.addEventListener('input', function (evt) {
    if (evt.target && evt.target.matches('.quick-cart [data-quantity-input], .quick-cart .quantity-input__input, .cart [data-quantity-input], .cart .quantity-input__input')) {
      scheduleUpdate(getScope(evt.target), 0);
    }
  });

  document.addEventListener('shopify:section:load', function (evt) {
    initScope(evt.target || document);
  });

    document.addEventListener('shopify:section:unload', function (evt) {
    disconnectSubtotalObserversWithin(evt.target || document);
  });

  var pageObserver = new MutationObserver(function (mutations) {
    var shouldInit = false;

    mutations.forEach(function (mutation) {
      if (!mutation.addedNodes || !mutation.addedNodes.length) return;

      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;

        if (
          node.matches('.quick-cart, .cart, [data-cart-cashback-summary], [data-quick-cart-subtotal-value], [data-main-cart-subtotal-value]') ||
          node.querySelector('.quick-cart, .cart, [data-cart-cashback-summary], [data-quick-cart-subtotal-value], [data-main-cart-subtotal-value]')
        ) {
          shouldInit = true;
        }
      });
    });

    if (shouldInit) {
      initScope(document);
    }
  });

  pageObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();